var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { weekDefaultDate } from '../../../helper/defaultDate';
import ApplyClientsDialog from './NewApplyClientsDialog';
var ImportFileDialog = (function (_super) {
    __extends(ImportFileDialog, _super);
    function ImportFileDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.startPickerOptions = {
            disabledDate: function (time) {
                var e_time = weekDefaultDate().End.format('yyyy-MM-dd');
                var correct = Date.now() - 8.64e7 <= time.getTime() && time.getTime() <= new Date(e_time).getTime();
                return !correct;
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                var s_time = weekDefaultDate().Tomorrow.format('yyyy-MM-dd');
                var correct = time.getTime() >= new Date(s_time).getTime() - 8.64e7;
                return !correct;
            }
        };
        _this.formData = {
            order_id: '',
            order_name: '',
            es_time: weekDefaultDate().Tomorrow.format('yyyy-MM-dd'),
            ee_time: weekDefaultDate().End.format('yyyy-MM-dd'),
            business_info: [],
            business_info_name: '',
            supplier_to_business_ids: [],
            group_ids: [],
            order_icomment: '',
            shop_ids: []
        };
        _this.uploadData = {
            order_name: '',
            business_info: '',
            es_time: weekDefaultDate().Tomorrow.format('yyyy-MM-dd'),
            ee_time: weekDefaultDate().End.format('yyyy-MM-dd'),
            order_icomment: ''
        };
        return _this;
    }
    ImportFileDialog.prototype.created = function () {
    };
    ImportFileDialog.prototype.mounted = function () {
    };
    ImportFileDialog.prototype.open = function () {
        this.formData = Object.assign({}, this.formData, {
            order_id: '',
            order_name: '',
            es_time: weekDefaultDate().Tomorrow.format('yyyy-MM-dd'),
            ee_time: weekDefaultDate().End.format('yyyy-MM-dd'),
            business_info: [],
            business_info_name: '',
            supplier_to_business_ids: [],
            group_ids: [],
            order_icomment: ''
        });
        this.clearFiles();
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    ImportFileDialog.prototype.chooseFile = function () {
        this.$refs.upload.clearFiles();
    };
    ImportFileDialog.prototype.clearFiles = function () {
        if (this.$refs.upload) {
            this.$refs.upload.clearFiles();
        }
    };
    ImportFileDialog.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    ImportFileDialog.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = '';
            url = "supplierclientapi/businessgoodsprice/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            if (this.importFailnum == 0) {
                this.$emit('search');
                this.dialogTableVisible = false;
                this.clearFiles();
                window._czc.push(["_trackEvent", '销售价格导入', '销售价格导入']);
            }
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    ImportFileDialog.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    ImportFileDialog.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    ImportFileDialog.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    ImportFileDialog.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    ImportFileDialog.prototype.applyClientsDg = function () {
        var _this = this;
        var dialog = this.$dialog(ApplyClientsDialog, {
            data: {
                supplier_to_business_ids: this.formData.supplier_to_business_ids,
                group_ids: this.formData.group_ids,
                shop_ids: this.formData.shop_ids
            }
        }, {
            title: "选择客户",
            width: 640,
            height: 530
        });
        dialog.instance.$on("submit", function (res) {
            _this.formData.supplier_to_business_ids = res.supplier_to_business_ids;
            _this.formData.group_ids = res.group_ids;
            _this.formData.business_info = res.business_info;
            _this.formData.business_info_name = res.business_info_name;
        });
    };
    ImportFileDialog.prototype.checkSave = function () {
        var flag = true, msg = [];
        if (!this.formData.order_name) {
            this.$message.warning("价格单名称不可为空");
            return false;
        }
        if (!this.formData.supplier_to_business_ids.length && !this.formData.group_ids.length) {
            this.$message.warning("应用客户不可为空");
            return false;
        }
        if (!flag) {
            this.$message.warning(msg[0]);
            return false;
        }
        return true;
    };
    ImportFileDialog.prototype.importFileOk = function () {
        if (!this.checkSave()) {
            return;
        }
        this.uploadData.order_name = this.formData.order_name;
        this.uploadData.business_info = JSON.stringify(this.formData.business_info);
        this.uploadData.es_time = this.formData.es_time;
        this.uploadData.ee_time = this.formData.ee_time;
        this.uploadData.order_icomment = this.formData.order_icomment;
        if (this.$refs.upload.uploadFiles.length == 0) {
            this.$message.warning("请选择需要导入的文件");
            return;
        }
        else {
            this.$refs.upload.uploadFiles.forEach(function (file) {
                file.percentage = 0;
                file.status = 'ready';
            });
        }
        this.afterImport = false;
        this.$refs.upload.submit();
    };
    ImportFileDialog.prototype.cancel = function () {
        this.dialogTableVisible = false;
        this.clearFiles();
        this.setUploadType('beford');
    };
    ImportFileDialog = __decorate([
        Component({
            components: {},
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            watch: {
                'formData.es_time': function (newVal, oldVal) {
                    this.endPickerOptions = {
                        disabledDate: function (time) {
                            var s_time = new Date(newVal).format('yyyy-MM-dd');
                            var correct = time.getTime() >= new Date(s_time).getTime() - 8.64e7;
                            return !correct;
                        }
                    };
                },
                'formData.ee_time': function (newVal, oldVal) {
                    this.startPickerOptions = {
                        disabledDate: function (time) {
                            var e_time = new Date(newVal).format('yyyy-MM-dd');
                            var correct = Date.now() - 8.64e7 <= time.getTime() && time.getTime() <= new Date(e_time).getTime();
                            return !correct;
                        }
                    };
                }
            }
        })
    ], ImportFileDialog);
    return ImportFileDialog;
}(Vue));
export default ImportFileDialog;
